import { CommonModule } from '@angular/common';
import { Component, computed, input } from '@angular/core';

@Component({
    standalone: true,
    selector: 'webstore-star-rating',
    templateUrl: './star-rating.component.html',
    styleUrls: ['./star-rating.component.scss'],
    imports: [CommonModule]
})
export class StarRatingComponent {


    readonly rating = input<number>(0);

    readonly starArray = computed((): Array<{ type: string, percentage?: number }> => {
        const stars = [];
        const ratingValue = this.rating();
        const fullStars = Math.floor(ratingValue);
        const hasPartialStar = ratingValue % 1 !== 0;
        const partialStarPercentage = hasPartialStar ? (ratingValue % 1) * 100 : 0;

        // Add full stars
        for (let i = 0; i < fullStars; i++) {
            stars.push({ type: 'full' });
        }

        // Add partial star if exists
        if (hasPartialStar) {
            stars.push({ type: 'partial', percentage: partialStarPercentage });
        }

        // Add empty stars
        const emptyStars = 5 - stars.length;
        for (let i = 0; i < emptyStars; i++) {
            stars.push({ type: 'empty' });
        }

        return stars;
    });
} 
